<template>
  <div v-if="isReady" class="panel-body">
    <transition name="fade-expand" mode="out-in">
      <div v-if="!selectedSale" key="open">
        <p class="text-size-20">募集中のセール情報一覧</p>
        <transition-group name="expand-card" tag="div" class="sale-grid">
          <sale-card
            v-for="sale in displayData"
            :key="sale.saleId"
            :sale="sale"
          />
        </transition-group>
      </div>
      <div v-else key="entry">
        <sale-entry :selectedSale="selectedSale" @backToTop="backToTop"/>
      </div>
    </transition>
  </div>
</template>

<script>
import SaleService from '@/services/salemasterservice'
import SaleCard from './components/SaleCard'
import SaleEntry from './SaleEntry'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    SaleCard,
    SaleEntry
  },
  data () {
    return {
      isReady: false,
      loader: null,
      searchQuery: [],
      saleIds: [],
      salesData: [],
      displayData: []
    }
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    },
    selectedSale () {
      return this.salesData.find(i => i.saleId === this.saleId)
    }
  },
  created () {
    this.getSales()
    this.searchQuery = this.$route.query.search_query ? this.$route.query.search_query.split(',').map(query => (query || '')) : []
    this.saleIds = this.$route.query.sale_ids ? this.$route.query.sale_ids.split(',').map(id => (id || '').toLowerCase()) : []
  },
  methods: {
    async getSales () {
      this.loader = this.$loading.show()
      await SaleService.getSaleOpen()
        .then((response) => {
          this.salesData = response.data
          if (this.searchQuery.length > 0 || this.saleIds.length > 0) {
            this.filterSales()
          } else {
            this.displayData = response.data
          }
          this.isReady = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    backToTop () {
      const query = {...this.$route.query}
      if (this.searchQuery) {
        query.search_query = this.searchQuery
      }

      if (this.saleIds.length > 0) {
        query.sale_ids = this.saleIds.join(',')
      }
      this.$router.replace({name: 'Sale', query: query})
    },
    filterSales () {
      const lower = str => str.toLowerCase()
      const matchIncludes = (target, keyword) => lower(target || '').includes(lower(keyword || ''))

      this.displayData = [...this.salesData].filter(i => {
        const matchSaleName = this.searchQuery.length === 0 || this.searchQuery.some(q => matchIncludes(i.saleName, q))
        const matchSaleId = this.saleIds.length === 0 || this.saleIds.some(sid => matchIncludes(i.saleId, sid))

        return matchSaleName || matchSaleId
      })
    }
  },
  mounted () {
    const logParams = {
      name: eventCode.sale.open,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.sale-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  align-items: stretch;
}

</style>



// WEBPACK FOOTER //
// src/view/sale/SaleOpen.vue